import { Component, OnInit, OnDestroy } from '@angular/core';
import { SocketEvent } from '@model/socket-event';
import { EventStreamService } from '@service/rest/event-stream.service';
import { SocketEventStorage } from '@storage/socket-event.storage';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-event-socket',
  templateUrl: './event-socket.component.html',
})
export class EventSocketComponent implements OnInit, OnDestroy {
  events: SocketEvent[] = [];
  intervalSource = interval(30000);
  intervalSubscription: Subscription;
  socketSubscription: Subscription;
  refreshSocketSubscription: Subscription;

  constructor(
    public eventStreamService: EventStreamService,
    public socketEventStorage: SocketEventStorage
  ) {
    this.refreshSocketSubscription = this.eventStreamService.getRefreshSocket().subscribe(res => {
      if (res) {
        this.socketSubscription?.unsubscribe();
        this.createSocketConnection();
      }
    });
  }

  ngOnInit() {
    this.createSocketConnection();
    this.triggerEvents();
  }

  ngOnDestroy() {
    this.intervalSubscription?.unsubscribe();
    this.socketSubscription?.unsubscribe();
    this.refreshSocketSubscription?.unsubscribe();
  }

  createSocketConnection(): void {
    this.socketSubscription = this.eventStreamService.getSocketEvents().subscribe(data => {
      if (data !== 'NOK') {
        const socketEvent: SocketEvent = JSON.parse(data);
        this.pushEvent(socketEvent);
      }
    });
  }

  pushEvent(event: SocketEvent) {
    this.events.push(event);
  }

  clearEvents(): void {
    this.events = [];
  }

  triggerEvents(): void {
    this.intervalSubscription = this.intervalSource.subscribe(() => {
      const eventsOfInterval: SocketEvent[] = JSON.parse(JSON.stringify(this.events));
      this.clearEvents();

      this.triggerMessageEvents(eventsOfInterval.filter(event => event.itemType === 'MESSAGE'));
      this.triggerMessageAndConversationEvents(eventsOfInterval.filter(event => event.itemType === 'MESSAGE' || event.itemType === 'CONVERSATION'));
      this.triggerFolderEvents(eventsOfInterval.filter(event => event.itemType === 'FOLDER'));
      this.triggerContactEvents(eventsOfInterval.filter(event => event.itemType === 'CONTACT'));
      this.triggerCalendarEvents(eventsOfInterval.filter(event => event.itemType === 'CALENDAR'));
    });
  }

  triggerMessageEvents(messageEvents: SocketEvent[]): void {
    if (messageEvents.length > 0) {
      this.socketEventStorage.refreshSocketMailEventInfo(messageEvents);
    }
  }

  triggerMessageAndConversationEvents(messageAndConversationEvents: SocketEvent[]): void {
    if (messageAndConversationEvents.length > 0) {
      this.socketEventStorage.refreshSocketMailAndConversationEventInfo(messageAndConversationEvents);
    }
  }

  triggerFolderEvents(folderEvents: SocketEvent[]): void {
    if (folderEvents.length > 0) {
      this.socketEventStorage.refreshSocketFolderEventInfo(folderEvents);
    }
  }

  triggerContactEvents(contactEvents: SocketEvent[]): void {
    if (contactEvents.length > 0) {
      this.socketEventStorage.refreshSocketContactEventInfo(contactEvents);
    }
  }

  triggerCalendarEvents(calendarEvents: SocketEvent[]): void {
    if (calendarEvents.length > 0) {
      this.socketEventStorage.refreshSocketCalendarEventInfo(calendarEvents);
    }
  }
}
